/**
 * Feature descriptions data for public preview pages
 * When user visits /campaign-manager without login, they see explanation of the feature
 */

const FEATURE_DATA = {
  'dashboard': {
    title: { en: 'School Dashboard', hi: 'स्कूल डैशबोर्ड' },
    desc: { en: 'Complete overview of your school — students, attendance, fees, performance — all in one screen.', hi: 'आपके school का पूरा overview — छात्र, उपस्थिति, फीस, performance — सब एक screen में।' },
    benefits: [
      { en: 'Real-time stats of students, teachers, attendance', hi: 'छात्र, शिक्षक, उपस्थिति की real-time stats' },
      { en: 'Fee collection tracking & pending alerts', hi: 'Fee collection tracking और pending alerts' },
      { en: 'Quick actions — add student, mark attendance, send notice', hi: 'Quick actions — छात्र जोड़ें, attendance लगाएं, notice भेजें' },
      { en: 'School health score & performance trends', hi: 'School health score और performance trends' },
    ],
    icon: '📊', color: 'from-blue-500 to-indigo-600', category: 'main',
  },
  'setup-guide': {
    title: { en: 'Setup Guide', hi: 'सेटअप गाइड' },
    desc: { en: '8-step guided setup to get your school live on the platform in under 30 minutes.', hi: '8-step guided setup — 30 मिनट में आपका school platform पर live।' },
    benefits: [
      { en: 'Step-by-step guided setup — no tech knowledge needed', hi: 'Step-by-step guided setup — tech knowledge ज़रूरी नहीं' },
      { en: 'Add classes, teachers, students in bulk', hi: 'Classes, teachers, students bulk में add करें' },
      { en: 'Set fee structure, timetable, WhatsApp — all guided', hi: 'Fee structure, timetable, WhatsApp — सब guided' },
      { en: 'Progress bar shows what is done, what is remaining', hi: 'Progress bar दिखाए क्या हुआ, क्या बाकी' },
    ],
    icon: '🎯', color: 'from-orange-500 to-amber-600', category: 'main',
  },
  'admission-engine': {
    title: { en: 'Admission Engine', hi: 'Admission Engine' },
    desc: { en: 'AI-powered admission automation — from parent inquiry to admission, everything on autopilot.', hi: 'AI से admission automation — parent inquiry से admission तक, सब autopilot पर।' },
    benefits: [
      { en: 'Live Seat Counter — IRCTC-style urgency creates 3x faster decisions', hi: 'Live Seat Counter — IRCTC जैसा urgency, 3x तेज़ decision' },
      { en: 'AI Entrance Exam — game-based, zero stress for children', hi: 'AI Entrance Exam — game-based, बच्चों को tension नहीं' },
      { en: 'Auto WhatsApp notifications to parents on every action', hi: 'हर action पर parents को auto WhatsApp notification' },
      { en: 'Lead tracking — new, contacted, visited, admitted', hi: 'Lead tracking — new, contacted, visited, admitted' },
    ],
    icon: '🚀', color: 'from-green-500 to-emerald-600', category: 'main',
  },
  'classes': {
    title: { en: 'Class Management', hi: 'कक्षा प्रबंधन' },
    desc: { en: 'Create and manage all classes, sections, and assign class teachers — organized and digital.', hi: 'सभी classes, sections बनाएं और class teachers assign करें — organized और digital।' },
    benefits: [
      { en: 'Create classes with sections (A, B, C) in one click', hi: 'Classes और sections (A, B, C) एक click में बनाएं' },
      { en: 'Assign class teachers to each section', hi: 'हर section में class teacher assign करें' },
      { en: 'Track student strength, capacity, and availability', hi: 'Student strength, capacity, availability track करें' },
      { en: 'Auto-link with attendance, exams, timetable', hi: 'Attendance, exams, timetable से auto-link' },
    ],
    icon: '📚', color: 'from-blue-500 to-cyan-600', category: 'academic',
  },
  'students': {
    title: { en: 'Student Management', hi: 'छात्र प्रबंधन' },
    desc: { en: 'Complete student database — admission details, parent info, documents, academic history — all in one place.', hi: 'पूरा student database — admission details, parent info, documents, academic history — सब एक जगह।' },
    benefits: [
      { en: 'Complete student profile with photo, parents, address', hi: 'पूरी student profile — photo, parents, address' },
      { en: 'Bulk import from Excel — 500 students in 2 minutes', hi: 'Excel से bulk import — 500 students 2 मिनट में' },
      { en: 'Search, filter by class, section, status instantly', hi: 'Class, section, status से instant search और filter' },
      { en: 'Transfer, promote, generate ID cards', hi: 'Transfer, promote, ID cards generate करें' },
    ],
    icon: '👨‍🎓', color: 'from-violet-500 to-purple-600', category: 'academic',
  },
  'teachers': {
    title: { en: 'Teacher Management', hi: 'शिक्षक प्रबंधन' },
    desc: { en: 'Complete teacher database with qualifications, subjects, timetable, salary, and leave management.', hi: 'पूरा teacher database — qualifications, subjects, timetable, salary, और leave management।' },
    benefits: [
      { en: 'Teacher profiles with qualifications, experience, documents', hi: 'Teacher profiles — qualifications, experience, documents' },
      { en: 'Subject and class assignment in one click', hi: 'Subject और class assignment एक click में' },
      { en: 'Attendance tracking for teachers', hi: 'Teachers की attendance tracking' },
      { en: 'Salary, leave, performance tracking integrated', hi: 'Salary, leave, performance tracking integrated' },
    ],
    icon: '👨‍🏫', color: 'from-teal-500 to-green-600', category: 'academic',
  },
  'attendance': {
    title: { en: 'Attendance Management', hi: 'उपस्थिति प्रबंधन' },
    desc: { en: 'Digital attendance — mark in 30 seconds, auto WhatsApp to absent students parents, monthly reports.', hi: 'Digital attendance — 30 second में mark करें, absent students के parents को auto WhatsApp, monthly reports।' },
    benefits: [
      { en: 'Mark full class attendance in 30 seconds', hi: '30 second में पूरी class की attendance mark करें' },
      { en: 'Auto WhatsApp alert to parents of absent students', hi: 'Absent students के parents को auto WhatsApp alert' },
      { en: 'Monthly/weekly reports — class-wise, student-wise', hi: 'Monthly/weekly reports — class-wise, student-wise' },
      { en: 'Track attendance percentage, trends, at-risk students', hi: 'Attendance percentage, trends, at-risk students track करें' },
    ],
    icon: '✅', color: 'from-green-500 to-emerald-600', category: 'academic',
  },
  'exams': {
    title: { en: 'Exams & Results', hi: 'परीक्षा व रिज़ल्ट' },
    desc: { en: 'Create exams, enter marks, auto-generate report cards with grades, rankings, and parent notifications.', hi: 'Exam बनाएं, marks डालें, auto report card generate हो — grades, rankings, parent notifications सब automatic।' },
    benefits: [
      { en: 'Create exam schedule with date, time, syllabus', hi: 'Exam schedule बनाएं — date, time, syllabus' },
      { en: 'Enter marks → auto-calculate grades, percentage, rank', hi: 'Marks डालें → auto grades, percentage, rank calculate हो' },
      { en: 'PDF report cards with school logo — WhatsApp to parents', hi: 'School logo वाला PDF report card — parents को WhatsApp' },
      { en: 'Subject-wise analysis — weak topics, class performance', hi: 'Subject-wise analysis — weak topics, class performance' },
    ],
    icon: '📝', color: 'from-red-500 to-rose-600', category: 'academic',
  },
  'timetable': {
    title: { en: 'Smart Timetable', hi: 'स्मार्ट समय सारणी' },
    desc: { en: 'AI generates clash-free timetable in seconds — teacher availability, room allocation, subject distribution.', hi: 'AI seconds में clash-free timetable बनाए — teacher availability, room allocation, subject distribution।' },
    benefits: [
      { en: 'AI generates optimal timetable — zero clashes guaranteed', hi: 'AI optimal timetable बनाए — zero clashes guaranteed' },
      { en: 'Drag-and-drop to modify any period', hi: 'Drag-and-drop से कोई भी period बदलें' },
      { en: 'Teacher-wise, class-wise, room-wise views', hi: 'Teacher-wise, class-wise, room-wise views' },
      { en: 'Substitute teacher auto-assignment on leave', hi: 'छुट्टी पर substitute teacher auto-assign' },
    ],
    icon: '🗓️', color: 'from-indigo-500 to-blue-600', category: 'academic',
  },
  'calendar': {
    title: { en: 'Academic Calendar', hi: 'शैक्षणिक कैलेंडर' },
    desc: { en: 'School calendar with holidays, events, exams, PTMs — visible to all staff, parents, and students.', hi: 'School calendar — छुट्टियां, events, exams, PTMs — सब staff, parents, students को दिखे।' },
    benefits: [
      { en: 'Add holidays, events, exams, PTM dates', hi: 'छुट्टियां, events, exams, PTM dates add करें' },
      { en: 'Color-coded — holidays (red), exams (blue), events (green)', hi: 'Color-coded — holidays (लाल), exams (नीला), events (हरा)' },
      { en: 'Auto-notify parents and staff before events', hi: 'Events से पहले parents और staff को auto-notify' },
      { en: 'Month/week/day views with filters', hi: 'Month/week/day views with filters' },
    ],
    icon: '📅', color: 'from-amber-500 to-orange-600', category: 'academic',
  },
  'fees': {
    title: { en: 'Fee Collection', hi: 'फीस Collection' },
    desc: { en: 'Online fee collection with Razorpay, auto receipts, WhatsApp reminders, and defaulter tracking.', hi: 'Razorpay से online fee collection, auto receipts, WhatsApp reminders, और defaulter tracking।' },
    benefits: [
      { en: 'Online payment via Razorpay — UPI, Card, NetBanking', hi: 'Razorpay से online payment — UPI, Card, NetBanking' },
      { en: 'Auto receipt generation + WhatsApp to parents', hi: 'Auto receipt generate + parents को WhatsApp' },
      { en: 'Defaulter list with auto WhatsApp reminders', hi: 'Defaulter list + auto WhatsApp reminders' },
      { en: 'Class-wise, month-wise fee collection reports', hi: 'Class-wise, month-wise fee collection reports' },
    ],
    icon: '💰', color: 'from-green-500 to-emerald-600', category: 'finance',
  },
  'fee-structure': {
    title: { en: 'Fee Structure', hi: 'शुल्क संरचना' },
    desc: { en: 'Set class-wise fee structure with installments, discounts, and late fee rules.', hi: 'Class-wise fee structure बनाएं — installments, discounts, और late fee rules।' },
    benefits: [
      { en: 'Class-wise annual, quarterly, monthly fee setup', hi: 'Class-wise annual, quarterly, monthly fee setup' },
      { en: 'Sibling discount, scholarship, early-bird rules', hi: 'Sibling discount, scholarship, early-bird rules' },
      { en: 'Late fee auto-calculation', hi: 'Late fee auto-calculate' },
      { en: 'Compare fees with nearby schools (Parent Portal)', hi: 'Parent Portal पर nearby schools से fees compare' },
    ],
    icon: '📋', color: 'from-teal-500 to-cyan-600', category: 'finance',
  },
  'wallet': {
    title: { en: 'School Wallet', hi: 'स्कूल वॉलेट' },
    desc: { en: 'Track all school transactions — income, expenses, balance — with AI usage credits management.', hi: 'School के सभी transactions track करें — income, expenses, balance — AI usage credits management।' },
    benefits: [
      { en: 'All income and expenses in one place', hi: 'सारी income और expenses एक जगह' },
      { en: 'AI credits usage tracking', hi: 'AI credits usage tracking' },
      { en: 'Transaction history with filters', hi: 'Filters के साथ transaction history' },
      { en: 'Balance alerts when credits run low', hi: 'Credits कम होने पर balance alerts' },
    ],
    icon: '💳', color: 'from-purple-500 to-violet-600', category: 'finance',
  },
  'padhai-emi': {
    title: { en: 'Padhai EMI', hi: 'पढ़ाई EMI' },
    desc: { en: 'NBFC pays you full fees on Day 1. Parents pay easy monthly EMIs. Zero fee default risk.', hi: 'NBFC आपको Day 1 पर पूरी fees दे। Parents आसान monthly EMI भरें। Fee default risk zero।' },
    benefits: [
      { en: 'School gets FULL FEES on Day 1 from NBFC', hi: 'School को Day 1 पर NBFC से पूरी FEES मिलें' },
      { en: 'Parents pay affordable monthly EMIs', hi: 'Parents affordable monthly EMI भरें' },
      { en: '0% interest for parents, guaranteed cash flow for school', hi: 'Parents को 0% interest, school को guaranteed cash flow' },
      { en: 'Zero default risk — NBFC handles collection', hi: 'Zero default risk — NBFC collection handle करे' },
    ],
    icon: '🏦', color: 'from-blue-500 to-indigo-600', category: 'finance',
  },
  'transport': {
    title: { en: 'Transport & GPS', hi: 'परिवहन और GPS' },
    desc: { en: 'School bus route management, driver details, student-bus mapping, and live GPS tracking for parents.', hi: 'Bus route management, driver details, student-bus mapping, और parents के लिए live GPS tracking।' },
    benefits: [
      { en: 'Create routes with stops, timing, driver details', hi: 'Routes बनाएं — stops, timing, driver details' },
      { en: 'Map students to bus routes', hi: 'Students को bus routes से map करें' },
      { en: 'Parents get bus arrival alerts on WhatsApp', hi: 'Parents को WhatsApp पर bus arrival alerts' },
      { en: 'Transport fee auto-linked with fee module', hi: 'Transport fee auto-linked with fee module' },
    ],
    icon: '🚌', color: 'from-yellow-500 to-amber-600', category: 'operations',
  },
  'hr-payroll': {
    title: { en: 'HR & Payroll', hi: 'HR और Payroll' },
    desc: { en: 'Complete staff management — salary calculation, attendance-based deductions, payslip generation.', hi: 'पूरा staff management — salary calculation, attendance-based deductions, payslip generation।' },
    benefits: [
      { en: 'Auto salary calculation based on attendance', hi: 'Attendance based auto salary calculation' },
      { en: 'Payslip PDF generation with school header', hi: 'School header के साथ Payslip PDF generate' },
      { en: 'Leave deduction, overtime, bonus management', hi: 'Leave deduction, overtime, bonus management' },
      { en: 'Monthly payroll reports, TDS tracking', hi: 'Monthly payroll reports, TDS tracking' },
    ],
    icon: '👨‍💼', color: 'from-slate-500 to-gray-600', category: 'operations',
  },
  'library': {
    title: { en: 'Library Management', hi: 'पुस्तकालय प्रबंधन' },
    desc: { en: 'Digital library — book catalog, barcode scanning, issue/return tracking, overdue alerts, reading analytics.', hi: 'Digital library — book catalog, barcode scanning, issue/return tracking, overdue alerts, reading analytics।' },
    benefits: [
      { en: 'Book catalog with barcode, genre, availability', hi: 'Barcode, genre, availability के साथ book catalog' },
      { en: 'Issue/return in one scan — barcode based', hi: 'एक scan में issue/return — barcode based' },
      { en: 'Overdue alerts on WhatsApp to parents', hi: 'Parents को WhatsApp पर overdue alerts' },
      { en: 'Reading analytics — who reads most, trending books', hi: 'Reading analytics — कौन सबसे ज़्यादा पढ़ता है, trending books' },
    ],
    icon: '📖', color: 'from-emerald-500 to-green-600', category: 'operations',
  },
  'leave-management': {
    title: { en: 'Leave Management', hi: 'छुट्टी प्रबंधन' },
    desc: { en: 'Staff and teacher leave apply, approve, track — with balance, history, and calendar view.', hi: 'Staff और teacher leave apply, approve, track — balance, history, और calendar view।' },
    benefits: [
      { en: 'Online leave application — no paper forms', hi: 'Online leave application — कागज़ की ज़रूरत नहीं' },
      { en: 'Admin approve/reject with one click', hi: 'Admin एक click में approve/reject करें' },
      { en: 'Leave balance tracking — CL, SL, EL, etc.', hi: 'Leave balance tracking — CL, SL, EL, etc.' },
      { en: 'Calendar view — who is on leave today', hi: 'Calendar view — आज कौन छुट्टी पर है' },
    ],
    icon: '📋', color: 'from-cyan-500 to-blue-600', category: 'operations',
  },
  'campaign-manager': {
    title: { en: 'Campaign Manager', hi: 'कैम्पेन मैनेजर' },
    desc: { en: 'Run Facebook Ads and Google Ads campaigns directly from your school dashboard — create, track, optimize.', hi: 'School dashboard से सीधे Facebook Ads और Google Ads campaigns चलाएं — create, track, optimize।' },
    benefits: [
      { en: 'Create Facebook Ads with AI-generated content', hi: 'AI-generated content के साथ Facebook Ads बनाएं' },
      { en: 'Google Ads keyword research + campaign creation', hi: 'Google Ads keyword research + campaign creation' },
      { en: 'Real-time performance dashboard — clicks, leads, cost', hi: 'Real-time performance — clicks, leads, cost dashboard' },
      { en: 'Cross-platform analytics — all campaigns in one view', hi: 'Cross-platform analytics — सब campaigns एक view में' },
    ],
    icon: '📢', color: 'from-pink-500 to-rose-600', category: 'marketing',
  },
  'lead-crm': {
    title: { en: 'Lead CRM', hi: 'लीड CRM' },
    desc: { en: 'Track every parent inquiry from first contact to admission — pipeline view, follow-up reminders, conversion tracking.', hi: 'हर parent inquiry track करें first contact से admission तक — pipeline view, follow-up reminders, conversion tracking।' },
    benefits: [
      { en: 'Pipeline view — New → Contacted → Visited → Admitted', hi: 'Pipeline view — New → Contacted → Visited → Admitted' },
      { en: 'Auto-capture leads from website, WhatsApp, walk-ins', hi: 'Website, WhatsApp, walk-ins से auto lead capture' },
      { en: 'Follow-up reminders — never miss a hot lead', hi: 'Follow-up reminders — कोई hot lead miss नहीं' },
      { en: 'Conversion rate analytics per source', hi: 'Source-wise conversion rate analytics' },
    ],
    icon: '🎯', color: 'from-orange-500 to-red-600', category: 'marketing',
  },
  'whatsapp': {
    title: { en: 'WhatsApp Integration', hi: 'WhatsApp Integration' },
    desc: { en: 'Official WhatsApp Business API — send attendance, fee reminders, exam results, and announcements to all parents.', hi: 'Official WhatsApp Business API — attendance, fee reminders, exam results, announcements सब parents को भेजें।' },
    benefits: [
      { en: 'Official Meta-approved WhatsApp Business API', hi: 'Meta-approved official WhatsApp Business API' },
      { en: '12 pre-approved templates — OTP, fees, attendance, results', hi: '12 pre-approved templates — OTP, fees, attendance, results' },
      { en: 'Bulk messaging to all parents — class-wise, school-wise', hi: 'सब parents को bulk messaging — class-wise, school-wise' },
      { en: 'Auto alerts — absent, fee due, exam results, events', hi: 'Auto alerts — absent, fee due, exam results, events' },
    ],
    icon: '💬', color: 'from-green-500 to-emerald-600', category: 'communication',
  },
  'ai': {
    title: { en: 'AI Features', hi: 'AI सुविधाएं' },
    desc: { en: '31 AI-powered features — from notice writing to question paper generation, everything automated.', hi: '31 AI-powered features — notice लिखने से question paper बनाने तक, सब automated।' },
    benefits: [
      { en: '31 AI tools for admin, teachers, students, parents', hi: 'Admin, teachers, students, parents के लिए 31 AI tools' },
      { en: 'Powered by GPT-5.2 — latest and most accurate AI', hi: 'GPT-5.2 powered — latest और सबसे accurate AI' },
      { en: 'Hindi + English — bilingual AI responses', hi: 'Hindi + English — bilingual AI responses' },
      { en: 'Question paper, report card, notice, complaint — all AI', hi: 'Question paper, report card, notice, complaint — सब AI' },
    ],
    icon: '🤖', color: 'from-violet-500 to-purple-600', category: 'ai',
  },
  'social-media': {
    title: { en: 'Social Media', hi: 'सोशल मीडिया' },
    desc: { en: 'Manage Instagram posts, stories, and engagement — all from your school dashboard.', hi: 'Instagram posts, stories, engagement — सब school dashboard से manage करें।' },
    benefits: [
      { en: 'Post to Instagram directly from dashboard', hi: 'Dashboard से सीधे Instagram पर post करें' },
      { en: 'Schedule posts in advance', hi: 'Posts advance में schedule करें' },
      { en: 'View engagement analytics — likes, comments, reach', hi: 'Engagement analytics देखें — likes, comments, reach' },
      { en: 'AI-generated captions and hashtags', hi: 'AI-generated captions और hashtags' },
    ],
    icon: '📱', color: 'from-pink-500 to-fuchsia-600', category: 'communication',
  },
  'school-analytics': {
    title: { en: 'School Analytics', hi: 'स्कूल एनालिटिक्स' },
    desc: { en: 'Health score, performance trends, attendance patterns, fee analytics — data-driven school management.', hi: 'Health score, performance trends, attendance patterns, fee analytics — data-driven school management।' },
    benefits: [
      { en: 'School Health Score — one number for overall performance', hi: 'School Health Score — overall performance एक number में' },
      { en: 'Attendance trends, fee collection patterns', hi: 'Attendance trends, fee collection patterns' },
      { en: 'Class-wise, subject-wise performance comparison', hi: 'Class-wise, subject-wise performance comparison' },
      { en: 'AI recommendations to improve weak areas', hi: 'Weak areas improve करने के लिए AI recommendations' },
    ],
    icon: '📈', color: 'from-blue-500 to-indigo-600', category: 'marketing',
  },
  'reports': {
    title: { en: 'Reports', hi: 'रिपोर्ट' },
    desc: { en: 'Ready-made reports — attendance, fees, exams, students — download as PDF or Excel.', hi: 'Ready-made reports — attendance, fees, exams, students — PDF या Excel में download करें।' },
    benefits: [
      { en: 'Pre-built reports for every module', hi: 'हर module के लिए pre-built reports' },
      { en: 'Download as PDF or Excel', hi: 'PDF या Excel में download' },
      { en: 'Custom date range, class filter, section filter', hi: 'Custom date range, class filter, section filter' },
      { en: 'Schedule auto-reports — email/WhatsApp weekly', hi: 'Auto-reports schedule — weekly email/WhatsApp' },
    ],
    icon: '📄', color: 'from-gray-500 to-slate-600', category: 'data',
  },
  'settings': {
    title: { en: 'School Settings', hi: 'स्कूल सेटिंग्स' },
    desc: { en: 'Configure school profile, branding, academic year, SMS/email settings, and user permissions.', hi: 'School profile, branding, academic year, SMS/email settings, user permissions configure करें।' },
    benefits: [
      { en: 'School profile — name, logo, address, board', hi: 'School profile — name, logo, address, board' },
      { en: 'Academic year, session, grading system setup', hi: 'Academic year, session, grading system setup' },
      { en: 'User roles and permissions management', hi: 'User roles और permissions management' },
      { en: 'Notification preferences — WhatsApp, SMS, email', hi: 'Notification preferences — WhatsApp, SMS, email' },
    ],
    icon: '⚙️', color: 'from-gray-500 to-zinc-600', category: 'settings',
  },
};

// Generate generic data for features not explicitly defined
const GENERIC_FEATURES = [
  'emergency-exit', 'lead-nurturing', 'follow-ups', 'communication', 'complaints',
  'notifications', 'newsletter', 'bulk', 'data-export', 'data-tasks',
  'audit-logs', 'documents', 'udise', 'ai-usage', 'doubt-history',
  'scheduler', 'domain-settings', 'schools', 'feature-editor', 'leave-requests',
  'portal-dashboard', 'portal-attendance', 'portal-fees', 'portal-announcements', 'portal-bus-tracking',
];

const GENERIC_LABELS = {
  'emergency-exit': { title: { en: 'Emergency Exit', hi: 'आपातकालीन निकास' }, icon: '🚨', color: 'from-red-500 to-rose-600' },
  'lead-nurturing': { title: { en: 'Lead Nurturing', hi: 'लीड Nurturing' }, icon: '🌱', color: 'from-green-500 to-teal-600' },
  'follow-ups': { title: { en: 'Follow-ups', hi: 'फॉलो-अप' }, icon: '⏰', color: 'from-amber-500 to-orange-600' },
  'communication': { title: { en: 'Announcements', hi: 'घोषणाएं' }, icon: '📢', color: 'from-blue-500 to-cyan-600' },
  'complaints': { title: { en: 'Complaints', hi: 'शिकायतें' }, icon: '📝', color: 'from-red-500 to-pink-600' },
  'notifications': { title: { en: 'Notifications', hi: 'सूचनाएं' }, icon: '🔔', color: 'from-yellow-500 to-amber-600' },
  'newsletter': { title: { en: 'Newsletter', hi: 'न्यूज़लेटर' }, icon: '📰', color: 'from-teal-500 to-green-600' },
  'bulk': { title: { en: 'Bulk Import', hi: 'बल्क इम्पोर्ट' }, icon: '📥', color: 'from-indigo-500 to-blue-600' },
  'data-export': { title: { en: 'Data Export', hi: 'डेटा एक्सपोर्ट' }, icon: '📤', color: 'from-cyan-500 to-blue-600' },
  'data-tasks': { title: { en: 'Data Tasks', hi: 'डेटा टास्क' }, icon: '📋', color: 'from-purple-500 to-indigo-600' },
  'audit-logs': { title: { en: 'Audit Logs', hi: 'ऑडिट लॉग' }, icon: '🕐', color: 'from-gray-500 to-slate-600' },
  'documents': { title: { en: 'Documents', hi: 'दस्तावेज़' }, icon: '📁', color: 'from-amber-500 to-yellow-600' },
  'udise': { title: { en: 'UDISE+ Portal', hi: 'UDISE+ पोर्टल' }, icon: '🏛️', color: 'from-blue-500 to-indigo-600' },
  'ai-usage': { title: { en: 'AI Usage', hi: 'AI उपयोग' }, icon: '📈', color: 'from-violet-500 to-purple-600' },
  'doubt-history': { title: { en: 'Doubt History', hi: 'डाउट हिस्ट्री' }, icon: '❓', color: 'from-orange-500 to-red-600' },
  'scheduler': { title: { en: 'Scheduler', hi: 'शेड्यूलर' }, icon: '⏰', color: 'from-blue-500 to-cyan-600' },
  'domain-settings': { title: { en: 'Custom Domain', hi: 'कस्टम डोमेन' }, icon: '🌐', color: 'from-green-500 to-teal-600' },
  'schools': { title: { en: 'School Management', hi: 'स्कूल प्रबंधन' }, icon: '🏫', color: 'from-blue-500 to-indigo-600' },
  'feature-editor': { title: { en: 'Feature Editor', hi: 'फीचर एडिटर' }, icon: '✏️', color: 'from-purple-500 to-violet-600' },
  'leave-requests': { title: { en: 'My Leave Requests', hi: 'मेरी छुट्टी' }, icon: '📋', color: 'from-cyan-500 to-blue-600' },
  'portal-dashboard': { title: { en: 'My Dashboard', hi: 'मेरा डैशबोर्ड' }, icon: '📊', color: 'from-blue-500 to-indigo-600' },
  'portal-attendance': { title: { en: 'My Attendance', hi: 'मेरी उपस्थिति' }, icon: '✅', color: 'from-green-500 to-emerald-600' },
  'portal-fees': { title: { en: 'My Fees', hi: 'मेरी फीस' }, icon: '💰', color: 'from-green-500 to-teal-600' },
  'portal-announcements': { title: { en: 'Announcements', hi: 'घोषणाएं' }, icon: '📢', color: 'from-blue-500 to-cyan-600' },
  'portal-bus-tracking': { title: { en: 'Bus Tracking', hi: 'बस ट्रैकिंग' }, icon: '🚌', color: 'from-yellow-500 to-amber-600' },
};

// Merge generic features into FEATURE_DATA
GENERIC_FEATURES.forEach(id => {
  if (!FEATURE_DATA[id]) {
    const g = GENERIC_LABELS[id] || { title: { en: id, hi: id }, icon: '📋', color: 'from-gray-500 to-slate-600' };
    FEATURE_DATA[id] = {
      ...g,
      desc: { en: `Manage ${g.title.en} for your school — digital, efficient, automated.`, hi: `अपने school के लिए ${g.title.hi} manage करें — digital, efficient, automated।` },
      benefits: [
        { en: 'Completely digital — no paper work', hi: 'पूरी तरह digital — कोई कागज़ी काम नहीं' },
        { en: 'Access from anywhere — mobile and desktop', hi: 'कहीं से भी access करें — mobile और desktop' },
        { en: 'Real-time updates and notifications', hi: 'Real-time updates और notifications' },
        { en: 'Integrated with WhatsApp for instant alerts', hi: 'WhatsApp से integrated — instant alerts' },
      ],
      category: 'other',
    };
  }
});

export default FEATURE_DATA;
